import Distribution from './Distribution';

export { default as Uniform } from './Uniform';
export { default as Power } from './Power';
export { default as Sin } from './Sin';

export default Distribution;
